module.exports = __webpack_public_path__ + "static/media/ascc.4afc9816.svg";